import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/organizations/")({
  beforeLoad: () => {
    throw redirect({ to: "/workspace/organizations" });
  },
});
